import { alpha, Theme } from '@mui/material';

export default {
    container: {
        flexShrink: 0,
        borderTop: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    fieldContainer: {
        minHeight: '44px',
        alignItems: 'flex-end',
        pl: 3,
        pr: 0.5,
    },
    sourcesInputRow: {
        minHeight: '44px',
        p: 1,
        pl: 3,
        pr: 3,
    },
    sourcesRow: {
        minHeight: '24px',
        pl: 3,
        pr: 1,
        mb: 1,
    },
    fieldHolder: {
        alignSelf: 'center',
        width: '100%',
    },
    sendButtonHolder: {
        position: 'relative',
    },
    abortHolder: {
        height: (theme: Theme) => theme.size.defaultHeight,
        display: 'flex',
        alignItems: 'center',
        pl: 1,
        mb: 1,
        '&:hover': {
            cursor: 'pointer',
            color: (theme: Theme) => theme.palette.primary.main,
        },
    },
    llmModelHolder: {
        position: 'absolute',
        right: '5px',
        bottom: '0px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.35),
    },
    field: {
        '.MuiInput-input': { lineHeight: '18px' },
        'textarea.alwaysShowPlaceholder::placeholder': {
            opacity: 1,
            color: (theme: Theme) => alpha(theme.palette.text.primary, 0.35),
        },
        'textarea.alwaysShowPlaceholder:focus::placeholder': {
            opacity: 1,
            color: (theme: Theme) => alpha(theme.palette.text.primary, 0.35),
        },
    },
    sendBtn: {
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.4),
        width: (theme: Theme) => theme.size.defaultHeight,
        height: (theme: Theme) => theme.size.defaultHeight,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        mb: 1,
        mr: 1,
        '&.active': {
            color: (theme: Theme) => theme.palette.primary.main,
            '&:hover': {
                opacity: 0.85,
                cursor: 'pointer',
            },
        },
    },
    newChatBtn: {
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        borderTop: '1px solid',
        borderTopColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        pt: '3px',
        px: 1.5,
        color: 'primary.main',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            cursor: 'pointer',
            borderTopColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.2),
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        },
        '&.disabled': {
            color: (theme: Theme) => alpha(theme.palette.text.primary, 0.4),
            cursor: 'default',
            '&:hover': {
                cursor: 'default',
                borderTopColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
            },
        },
    },
};
